/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

function SelectDropdown({
  options = [],
  onSelect = () => {},
  defaultOption = null,
  placeholder = '',
  select = null,
}) {
  const [selected, setSelected] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    setSelected(defaultOption);
  }, []);

  useEffect(() => {
    if (select) setSelected(select);
  }, [select]);

  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleToogle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="tv-select__container" onBlur={handleBlur} ref={selectRef}>
      <SelectorDisplay
        selected={selected}
        placeholder={placeholder}
        toogle={handleToogle}
      />
      <SelctorDropdownToogle setIsOpen={setIsOpen} isOpen={isOpen} />
      <ul
        className={`tv-select__drop-down-container ${
          isOpen && 'tv-select__drop-down--open'
        }`}
      >
        {options.map(item => (
          <OptionItem
            selected={selected}
            item={item}
            onSelect={onSelect}
            setIsOpen={setIsOpen}
          />
        ))}
      </ul>
    </div>
  );
}

SelectDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      displayText: PropTypes.string.isRequired,
    }),
  ),
  defaultOption: PropTypes.shape({
    displayText: PropTypes.string,
  }),
  select: PropTypes.shape({
    displayText: PropTypes.string,
  }),
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
};

export default SelectDropdown;

function OptionItem({ selected, item, onSelect, setIsOpen }) {
  return (
    <li
      className={`tv-select__drop-down-item ${
        selected &&
        selected.key === item.key &&
        'tv-select__drop-down-item--selected'
      }`}
      key={item.key}
      onClick={() => {
        onSelect(item);
        setIsOpen(false);
      }}
    >
      {item.displayText}
    </li>
  );
}

function SelectorDisplay({ selected, placeholder, toogle }) {
  return (
    <span
      className={`tv-select__display ${
        !selected && 'tv-select__display--default'
      }`}
      onClick={toogle}
    >
      {selected?.displayText || placeholder}
    </span>
  );
}

function SelctorDropdownToogle({ setIsOpen, isOpen }) {
  return (
    <div
      className="tv-select__display-icon material-icons"
      onClick={() => setIsOpen(!isOpen)}
    >
      {!isOpen ? 'arrow_drop_down' : 'arrow_drop_down'}
    </div>
  );
}
